import React from "react";
import { useState } from "react";
import ProductDetail from "./ProductDetail";
import ProductItem from "./ProductItem";

var productObj = {
  productId: 0,
  text: "Bitte Produkt auswählen.",
  category: "",
  price: "",
  currency: "",
  description: "",
  available: false,
};

const ProductList = () => {
  const [productArray, setProductArray] = useState([
    {
      productId: 1,
      text: "Shampoo #1",
      category: "Shampoo",
      price: "1.00",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: true,
    },
    {
      productId: 2,
      text: "Shampoo #2",
      category: "Shampoo",
      price: "2.50",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: false,
    },
    {
      productId: 3,
      text: "Conditioner #1",
      category: "Conditioner",
      price: "3.00",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: false,
    },
    {
      productId: 4,
      text: "Conditioner #2",
      category: "Conditioner",
      price: "1.50",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: true,
    },
    {
      productId: 5,
      text: "Conditioner #3",
      category: "Conditioner",
      price: "4.00",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: true,
    },
    {
      productId: 6,
      text: "Conditioner #4",
      category: "Conditioner",
      price: "5.00",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: false,
    },
    {
      productId: 7,
      text: "Conditioner #5",
      category: "Conditioner",
      price: "6.00",
      currency: "EUR",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      available: true,
    },
  ]);

  const displayProduct = (product) => {
    console.log(product.productId);
    productObj = product;
  };

  return (
    <div className="ProductContainer">
      <div className="ProductList">
        {productArray.map((product) => (
          <ProductItem
            key={product.productID}
            product={product}
            bgColor="white"
            color="#7c0070"
            text={product.text}
            onDisplay={displayProduct}
          />
        ))}
      </div>
      <div className="ProductDetail">
        <ProductDetail
          text={productObj.text}
          category={productObj.category}
          description={productObj.description}
          price={productObj.price}
          currency={productObj.currency}
        />
      </div>
    </div>
  );
};

export default ProductList;
